import type { AuthAccountLoginResponse } from 'api/auth'
import { BUSINESS_TRAVELLER_TENANT, LUXURY_ESCAPES_TENANT } from 'constants/tenants'

export interface EmployeeAccounts {
  personal: AuthAccountLoginResponse
  work: AuthAccountLoginResponse
}

export function validateEmployeeAccounts({ personal, work }: EmployeeAccounts, email: string) {
  if (work.account.tenant !== BUSINESS_TRAVELLER_TENANT || !work.accessToken ||
    !work.account.memberId || work.account.email?.toLowerCase() !== email.toLowerCase()) {
    throw new Error('Please sign in to the Business Traveller account matching your invitation email.')
  }
  if (personal.account.tenant !== LUXURY_ESCAPES_TENANT || !personal.accessToken || !personal.account.memberId ||
    !personal.account.email || personal.account.memberId === work.account.memberId) {
    throw new Error('A separate Luxury Escapes account is required for credits.')
  }
}
